import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { connectToStore } from '../../store';
import ExpertList from './expert-list/ExpertList';
import ExpertDetails from './expert-details/ExpertDetails';
import NotFound from '../not-found/NotFound';
import styles from './Experts.module.scss';

const subRoutes = [
	{
		path: `/`,
		exact: true,
		component: ExpertList,
	},
	{
		path: `/details/:id`,
		exact: true,
		component: ExpertDetails,
	},
];

function Experts() {
	const { path } = useRouteMatch();

	return (
		<div className={styles.screen}>
			<Switch>
				{/* Routes */}
				{subRoutes.map((route, index) => (
					<Route key={index} path={`${path}${route.path}`} exact={route.exact}>
						<route.component />
					</Route>
				))}

				{/* 404 */}
				<Route path="*">
					<NotFound />
				</Route>
			</Switch>
		</div>
	);
}

export default connectToStore(Experts);
